<script>
  import { getContext } from "svelte";
  import ButtonLabel from "#lib/ButtonLabel.svelte";
  import Popover from "#lib/Popover.svelte";
  import Divider from "#lib/Divider.svelte";
  import { ENTRIES } from '#lib/app_config.js';
  import t from "#lib/i18n.svelte.js";
  import { BLOCKS } from '#lib/app_config.js';

  let entry_api = getContext("entry_api");
  // let is_open = $state(false);
  // let anchor_ref = $state();
  // let popover_ref = $state();

  async function add_block_after() {
    await entry_api.active_container.add_block('story', { description: '' });
  }
</script>

<!-- bind:this={anchor_ref} popovertarget='add_after_tool_popover' -->
<button title={t('add_block')} onclick={add_block_after}>
  <ButtonLabel variant='brand ghostly text-compact' start_icon='plus'>{t('block')}</ButtonLabel>
</button>

<!-- <Popover
  anchor={anchor_ref}
  id='add_after_tool_popover'
  bind:ref={popover_ref}
  placement='bottom-start'
  class='normal'
>
  <Divider label={t('basic_blocks')} />
  {#each entry_api?.active_container?.block_types as block_type, i}
    {#if block_type === 'embed'}
      <Divider label={t('embed_entries')} />
      {#each Object.values(ENTRIES) as entry_type}
        <button
          data-block-type={block_type}
          onclick={async ()=>{
            await entry_api.active_container.add_block(block_type, { query: { entry_type: entry_type.id}});
            is_open = false;
          }}
        >
          <ButtonLabel align='start' start_icon={entry_type.icon}>
            {t(entry_type.label_i18n)}
          </ButtonLabel>
        </button>
      {/each}
    {:else}
      <button
        data-block-type={block_type}
        onclick={async ()=>{
          await entry_api.active_container.add_block(block_type);
          is_open = false;
        }}
      >
        <ButtonLabel align='start'>{t(BLOCKS[block_type].label_i18n)}</ButtonLabel>
      </button>
    {/if}
  {/each}
</Popover> -->
